{
    "name": "upnp-client-ts",
    "version": "1.1.1",
    "description": "A modern UPNP client made in Typescript.",
    "source": "src/index.ts",
    "main": "dist/main.js",
    "module": "dist/module.js",
    "types": "dist/types.d.ts",
    "scripts": {
        "watch": "parcel watch",
        "build": "parcel build",
        "lint": "tsc --noEmit && eslint \"src/**/*.ts{,x}\""
    },
    "targets": {
        "module": {
            "isLibrary": true,
            "context": "node"
        },
        "main": {
            "isLibrary": true,
            "context": "node"
        }
    },
    "keywords": [
        "upnp",
        "client",
        "mediarenderer",
        "typescript",
        "module"
    ],
    "author": "Corentin Mors <corentin@pixelswap.fr>",
    "license": "MIT",
    "devDependencies": {
        "@parcel/packager-ts": "^2.10.3",
        "@parcel/transformer-typescript-tsc": "^2.10.3",
        "@parcel/transformer-typescript-types": "^2.10.3",
        "@types/elementtree": "^0.1.5",
        "@types/node": "^18.11.18",
        "@typescript-eslint/eslint-plugin": "^6.16.0",
        "@typescript-eslint/parser": "^6.16.0",
        "eslint": "^8.56.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-prettier": "^5.1.2",
        "parcel": "^2.10.3",
        "prettier": "^3.1.1",
        "typescript": "^5.3.3"
    },
    "dependencies": {
        "elementtree": "^0.1.7"
    },
    "@parcel/transformer-js": {
        "inlineFS": false
    },
    "files": [
        "dist"
    ],
    "repository": {
        "type": "git",
        "url": "https://github.com/Mikescops/upnp-client-ts.git"
    },
    "publishConfig": {
        "registry": "https://registry.npmjs.org"
    },
    "engines": {
        "node": ">=18.0.0"
    }
}
